import { Button } from '@webmotors/eleanor-ui';
import { BaseModal } from '@/components/base-modal';
import { useConfirmationModal } from './confirmation-modal.hook';
import { confirmationModalStyles } from './confirmation-modal.styles';
import { CONFIRMATION_MODAL } from './utils';
import { SHARED_TEST_IDS } from '@/utils';
import type { TConfirmationModalConfig } from './confirmation-modal.types';

const ConfirmationModal = ({
	isOpen,
	onClose,
	title,
	children,
	confirmLabel,
	cancelLabel = CONFIRMATION_MODAL.DEFAULT_CANCEL_LABEL,
	onConfirm,
	onCancel,
	isLoading = false,
	dataTestId
}: TConfirmationModalConfig) => {
	const { handleOpenChange, handleCancel } = useConfirmationModal({ onClose, onCancel, isLoading });

	return (
		<BaseModal
			open={isOpen}
			onOpenChange={handleOpenChange}
			title={title}
			titleId={CONFIRMATION_MODAL.TITLE_ID}
			size="sm"
			preventClose={isLoading}
			dataTestId={dataTestId}
		>
			<div className={confirmationModalStyles.stack}>
				<div className={confirmationModalStyles.bodyText}>{children}</div>

				<div className={confirmationModalStyles.actionsRow}>
					<Button
						variant="tertiary-situational"
						size="medium"
						onClick={handleCancel}
						state={isLoading ? 'disabled' : 'active'}
						data-testid={SHARED_TEST_IDS.CONFIRMATION_MODAL_CANCEL_BUTTON}
					>
						{cancelLabel}
					</Button>
					<Button
						variant="primary"
						size="medium"
						onClick={onConfirm}
						state={isLoading ? 'disabled' : 'active'}
						isLoading={isLoading}
						data-testid={SHARED_TEST_IDS.CONFIRMATION_MODAL_CONFIRM_BUTTON}
					>
						{confirmLabel}
					</Button>
				</div>
			</div>
		</BaseModal>
	);
};

ConfirmationModal.displayName = 'ConfirmationModal';

export { ConfirmationModal };
